// Tablet (768–1023 px, docs/mobile/SPEZIFIKATION.md §6.4): Die Seitenleiste ist dort eine feste Schiene mit Symbolen.
// Die Schaltfläche „Navigation öffnen“ (Topbar, ⌘B) legt die volle Seitenleiste darüber – mit Namen, Gruppen,
// Einstellungen und Benutzer. Sie schließt nach der Auswahl, per Wisch nach links, mit Esc und mit der Zurück-Taste.
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { useRef, type MouseEvent } from 'react'
import { useSwipeDismiss } from '../lib/useSwipeDismiss'
import { shell, useShellStore } from '../stores/shell'
import { LayerProvider, useLayer, Z } from '../ui/context'
import { backdropClass } from '../ui/Modal'
import type { Navigation } from './nav'
import { Sidebar } from './Sidebar'

export function NavOverlay({ navigation, onShowShortcuts }: { navigation: Navigation; onShowShortcuts?: () => void }) {
  const open = useShellStore((state) => state.mobileNavOpen)
  const zIndex = useLayer(Z.drawer)
  const panel = useRef<HTMLDivElement | null>(null)
  const close = (): void => shell.setMobileNav(false)
  const swipe = useSwipeDismiss(panel, 'left', close)
  // ein Verweis schließt – auch auf die Seite, auf der man schon steht (dann ändert sich der Pfad nicht)
  const closeOnLink = (event: MouseEvent<HTMLDivElement>): void => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey) close()
  }
  return (
    <BaseDialog.Root open={open} onOpenChange={shell.setMobileNav}>
      <BaseDialog.Portal>
        <BaseDialog.Backdrop className={backdropClass} style={{ zIndex }} />
        <BaseDialog.Popup
          ref={panel}
          aria-label="Navigation"
          data-testid="nav-overlay"
          data-ui="drawer"
          onClick={closeOnLink}
          {...swipe}
          style={{ zIndex }}
          className={
            'fixed inset-y-0 left-0 flex max-w-[85vw] touch-pan-y bg-canvas text-fg shadow-lg outline-none ' +
            'pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] ' +
            'transition-[opacity,translate] duration-(--duration-sheet) ease-out data-ending-style:duration-(--duration-base) data-ending-style:ease-in ' +
            'data-starting-style:-translate-x-full data-ending-style:-translate-x-full motion-reduce:transition-none'
          }
        >
          <BaseDialog.Title className="sr-only">Navigation</BaseDialog.Title>
          <LayerProvider z={zIndex}>
            <Sidebar navigation={navigation} collapsed={false} onShowShortcuts={onShowShortcuts} />
          </LayerProvider>
        </BaseDialog.Popup>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  )
}
